import React, { useContext, createContext, PropsWithChildren } from 'react'
const oauthClient = require('api/auth')
const user = require('stores/user')

export type BlockType = 'email' | 'phone' | 'address'

export interface BlockedCustomer {
  id: number
  type: BlockType
  value: string
  lat: number
  lng: number
  errors?: Record<string, string[]>
}

export interface BlockCustomerAPI {
  apiAvailable: boolean
  createBlockedCustomer: (blockedCustomer: Partial<BlockedCustomer>) => Promise<BlockedCustomer>
  checkBlockedCustomer: (type: string, value: string | Partial<BlockedCustomer>) => Promise<{ blocked: boolean }>
}

const authJsonHeaders = (token: string): any => {
  return {
    'Content-Type': 'application/json',
    Authorisation: `Bearer ${token}`,
    Authorization: `Bearer ${token}`,
  }
}

const BlockCustomerAPICtx = createContext<BlockCustomerAPI | null>(null)

function createBlockedCustomerURL(): string {
  return `${RESTAURANTS_SVC_API5}/v5/block_customer`
}

export function BlockCustomerSvc(props: PropsWithChildren<{}>): JSX.Element {
  const token = oauthClient.getAuthResponse() ? oauthClient.getAuthResponse().access_token : null
  const canAccessAPI = !!['config', 'billing_admin', 'admin', 'support'].find((role: string) =>
    user.roles().includes(role)
  )

  if (!token) return <>Loading...</>

  const api: BlockCustomerAPI = {
    apiAvailable: canAccessAPI,
    createBlockedCustomer: async (blockedCustomer: Partial<BlockedCustomer>): Promise<BlockedCustomer> => {
      return fetch(createBlockedCustomerURL(), {
        method: 'POST',
        headers: authJsonHeaders(token),
        body: JSON.stringify({ blocked_customer: blockedCustomer }),
      }).then((res) => (res.ok ? res.json() : res.json().then((data) => Promise.reject(data))))
    },
    checkBlockedCustomer: async (
      type: BlockType,
      searchParams: string | Partial<BlockedCustomer>
    ): Promise<{ blocked: boolean }> => {
      const headers = authJsonHeaders(token)
      const body = JSON.stringify({ search: { [type]: searchParams } })
      return fetch(`${createBlockedCustomerURL()}/search`, {
        method: 'POST',
        headers: headers,
        body: body,
      }).then((res) => (res.ok ? res.json() : res.json().then((data) => Promise.reject(data))))
    },
  }
  return <BlockCustomerAPICtx.Provider value={api}>{props.children}</BlockCustomerAPICtx.Provider>
}

export function useBlockCustomerAPI(): BlockCustomerAPI {
  const ctx = useContext(BlockCustomerAPICtx)
  return ctx as BlockCustomerAPI
}
